module.exports = __webpack_public_path__ + "media/images/gifts/open_end/sug_aberto_14-497812baec183b066385e61c3ead327b.jpg";